import MenuHeader from "../../components/MenuHeader";
import MenuItem from "../../components/MenuItem";
import UserProfile from "../../components/UserProfile";

export default function Profile() {
    return (<>
    <UserProfile />
    
    <MenuHeader title="موارد بیشتر" />
    <MenuItem to="/soon" icon="fa-solid fa-graduation-cap" text="آموزش" />
    <MenuItem to="/soon" icon="fa-solid fa-mug-hot" text="درباره ما" />
    <MenuItem to="/soon" icon="fa-solid fa-bug" text="گزارش خطا" />
    <MenuItem to="/soon" icon="fa-solid fa-circle-question" text="پشتیبانی" />
    </>)
}